

exports.__esModule = true;
exports.$xoFrameBustPageDirective = undefined;

var _index = require('squid/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoFrameBustPageDirective = exports.$xoFrameBustPageDirective = _index.$Component.extend('$xoFrameBustPageDirective', {

    tag: 'xo-framebust-page',
    template: _template2['default'],

    props: {},

    resolve: {},

    actions: {
        submit: function submit() {
            window.paypalCheckout.hide();

            var url = window.location.href.split('#')[0];
            var props = angular.extend({}, window.paypalCheckout.props, { url: url });

            return window.ppxo.PayPalCheckout.init(props).renderPopupToParent();
        }
    }
});

angular.value("$xoFrameBustPageDirective", $xoFrameBustPageDirective);
_index.$Component;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-framebust/directive.js
 ** module id = 426
 ** module chunks = 1
 **/